import { API } from "./axiosInstance"

/**
 * Gets all the functionalityMemberUsergroups with joined
 * tables containing necessary information of parent objects from
 * usermanagement-service.
 * @param {*} userGroupId The ID of the usergroup for which all
 * functionalityMemberUsergroups are being retrieved.
 * @returns the functionalityMemberUsergroups containing necessary
 * information of parent objects
 */
export const getFunctionalitiesMembersUsergroups = async (userGroupId) => {
    const functionalitiesMembersUsergroups = await API.get(`/functionalitiesMembersUsergroups?userGroupId=${userGroupId}`);
    return functionalitiesMembersUsergroups.data;
}

/**
 * Calls the post functionalityMemberUsergroup endpoint
 * @param {*} functionalityMemberUsergroup the functionalityMemberUsergroup to create
 * @returns the response from usermanagement-service
 */
export const createFunctionalityMemberUsergroup = async (functionalityMemberUsergroup) => {
    const response = await API.post(`/functionalitiesMembersUsergroups`, functionalityMemberUsergroup);
    return response.data;
}

/**
 * Calls the put functionalityMemberUsergroup endpoint
 * @param {*} functionalitiesMembersUsergroup the functionalityMembersUsergroup to update
 * @param {*} staticId the id of the functionalityMemberUsergroup to update
 * @returns the response from usermanagement-service
 */
export const updateFunctionalityMemberUsergroup = async (functionalityMemberUsergroup, staticId) => {
    const response = await API.put(`/functionalitiesMembersUsergroups/${staticId}`, functionalityMemberUsergroup);
    return response.data;
}

/**
 * Rejects a requested change for a functionalityMemberUsergroup
 * @param {*} staticId the id of the functionalityMemberUsergroup in the static model
 * @returns the rejected functionalityMemberUsergroup
 */
export const rejectChange = async(staticId) => {
    const response = await API.post(`/functionalitiesMembersUsergroups/${staticId}/reject`);
    return response.data;
}

/**
* Accepts a requested change for a functionalityMemberUsergroup
* @param {*} staticId the id of the functionalityMemberUsergroup in the static model
* @param {*} body An object containing the body that should be sent. This may contain
* for example {acceptedHDNIndexTerms: true}.
* @returns the accepted functionalityMemberUsergroup
*/
export const acceptChange = async(staticId, body) => {
    const response = await API.post(`/functionalitiesMembersUsergroups/${staticId}/accept`, body);
    return response.data;
}
